export default __webpack_public_path__ + "static/media/ic_package.d029ebd4.png";